import React, { Component } from 'react';
import classNames from "classnames"

import firebase from 'firebase/app';
import 'firebase/auth';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import '../../styles/firebaseui-styling.global.css'; // Import globally.
import './overrides.global.css';

// import Logo from '../Logo/Logo';
// import Loading from '../Loading/Loading';
// import Button from '../Button/Button';
import styles from './Login.module.css';


const uiConfig = {
  callbacks: {
    signInSuccessWithAuthResult: function(authResult, redirectUrl) {
      // User successfully signed in.
      // Return type determines whether we continue the redirect automatically
			// or whether we leave that to developer to handle.
			console.log('signin success, authResult, redirectUrl: ', authResult, redirectUrl);
			console.log('this.props.destination: ', this.props.destination);
      return false;
    },
    uiShown: function() {
      // The widget is rendered.
      // Hide the loader.
      document.getElementById('loader').style.display = 'none';
    }
  },
  // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
  signInFlow: 'popup',
  signInSuccessUrl: '/',
  signInOptions: [
    // Leave the lines as is for the providers you want to offer your users.
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
		// firebase.auth.TwitterAuthProvider.PROVIDER_ID,
    // firebase.auth.GithubAuthProvider.PROVIDER_ID,
    firebase.auth.EmailAuthProvider.PROVIDER_ID,
    // firebase.auth.PhoneAuthProvider.PROVIDER_ID
  ],
  // Terms of service url.
  tosUrl: 'https://mycastle.app/tos',
  // Privacy policy url.
  privacyPolicyUrl: 'https://mycastle.app/privacy'
};


// const firebaseConfig = require('./firebase-config.json').result;
// const firebaseApp = firebase.initializeApp(uiConfig);
const firebaseApp = !firebase.apps.length ? firebase.initializeApp(uiConfig) : firebase.app();


export default class Login extends Component {
  uiConfig = {
    signInFlow: 'redirect',
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      firebase.auth.EmailAuthProvider.PROVIDER_ID,
    ],
    callbacks: {
      signInSuccessWithAuthResult: () => false,
    },
    'credentialHelper': 'none'
  };

	state = {
    isSignedIn: undefined,
		isLoggingIn: false,
		isError: false,
	}
  componentDidMount() {
    this.unregisterAuthObserver = firebaseApp.auth().onAuthStateChanged((user) => {
      this.setState({isSignedIn: !!user});
    });
  }

  /**
   * @inheritDoc
   */
  componentWillUnmount() {
    this.unregisterAuthObserver();
  }
	render() {
		const {
			isLoggingIn,
			isError,
			errorCode,
			errorMessage,
			} = this.state;
		const {
			destination = "/",
		} = this.props;
		return (
			<div className={classNames(styles.Login, {
				[styles.isActive] : isLoggingIn,
				[styles.isError] : isError
				})}>
				<div className={styles.content}>
				{isError &&
					<div className={styles.errorContent}>
						<label>ERROR {errorCode}</label>
						<p>{errorMessage}</p>
					</div>
				}
        {this.state.isSignedIn !== undefined && !this.state.isSignedIn &&
          <div>
            <StyledFirebaseAuth
            	className={styles.firebaseUi}
            	uiConfig={this.uiConfig}
              firebaseAuth={firebaseApp.auth()}
              />
          </div>
        }
        {this.state.isSignedIn &&
          <div className={styles.signedIn}>
            Hello {firebaseApp.auth().currentUser.displayName}. You are now signed In!
            <a className={styles.button} onClick={() => firebaseApp.auth().signOut()}>Sign-out</a>
          </div>
        }
        </div>
      </div>
		)
	}

	// doSubmitLogout() {
	// 	firebase.auth().signOut();
	// }
	doSubmitLogin() {
		const {username, password} = this.state;
		this.setState({
			isLoggingIn: true,
			isError: false,
			errorCode: null,
			errorMessage: null,
		});
			if(username && password){
			firebase.auth()
			.signInWithEmailAndPassword(username, password)
			.catch((error) => {
				console.log('ERROR: ', error);
		  	var errorCode = error.code;
				var errorMessage = error.message;
				console.log(error);
				this.setState({
					isError: true,
					isLoggingIn: false,
					errorCode: errorCode,
					errorMessage: errorMessage,
				})
			});
		} else {
			this.setState({
				isError: true,
				isLoggingIn: false,
				errorCode: 0,
				errorMessage: 'Missing email or password',
			})			
		}
	}
}

/*
				.then((user) => {
				console.log('verification email stage data: ', user);
				user.sendEmailVerification().then(function() {
					  // Email sent.
					  console.log('email sent');
					  this.setState({
						  verificationSent: true
					  })
					}).catch(function(error) {
					  // An error happened.
					});
			})

*/


// WEBPACK FOOTER //
// ./src/components/Login/Login.jsx